// 서버 RPC 적용과 역할별 검증 후 빌드 환경에서 명시적으로 켠다.
export const USER_BRIEFING_ENABLED = import.meta.env.VITE_USER_BRIEFING === 'true';
